export const SERVICES = 'SERVICES';
export const DATE_TIME = 'DATE_TIME';
export const BOOK_APPOINTMENT = 'BOOK_APPOINTMENT';
export const SELECTED_CC = 'SELECTED_CC';
export const PAYMENT = 'PAYMENT';   
export const MY_CAREGIVERS = 'MY_CAREGIVERS';